import {Component, OnInit} from '@angular/core';
import {RadiusAuthenticationApiService} from '../../../services/api/settings/administration/radius-authentication/radius-authentication-api.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import * as _ from 'lodash';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';
import {forkJoin} from 'rxjs';
import {SecurityPoliciesApiService} from '../../../services/api/settings/administration/security-policies/security-policies-api.service';

@Component({
  selector: 'radius-authentication',
  templateUrl: './radius-authentication.component.html',
  styleUrls: ['./radius-authentication.component.scss'],
})
export class RadiusAuthenticationComponent implements OnInit {

  canSubmit: boolean;
  testResult = '';
  testResultServer = '';

  securityLevelsOptions;

  radiusAuthentication: any = {testConnectivity: {}};
  authenticationOrderList: any = [{description: 'External first', bool: false},
    {description: 'Local first', bool: true}];

  constructor(
    private radiusAuthenticationApiService: RadiusAuthenticationApiService,
    private securityPoliciesApiService: SecurityPoliciesApiService,
    private userPrivilege: UserPrivilegeService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.loaderService.showMainContainer();
    this.initialization();
  }

  submit(): void {
    this.testResult = '';
    this.testResultServer = '';
    const parameters = _.cloneDeep(this.radiusAuthentication);
    parameters.defaultRole = parameters.defaultRole === -1 ? null : parameters.defaultRole;
    this.radiusAuthenticationApiService.updateAuthenticationRadiusConfiguration(parameters).subscribe(() => {});
  }

  testConnectivity(): void {
    const parameters = _.cloneDeep(this.radiusAuthentication);

    parameters.defaultRole = parameters.defaultRole === -1 ? null : parameters.defaultRole;
    this.testResult = '';
    this.testResultServer = '';
    this.radiusAuthenticationApiService.testAuthenticationRadiusConfiguration(parameters).subscribe(() => {
      this.testResult = 'RADIUS server connection test successful';
    }, (fail) => {
      if (fail.error && fail.error.description) {
        this.testResult = 'Failed: ' + fail.error.description;
      } else{
        this.testResult = 'Failed: please check your parameters';
      }
    });
  }

  testServerConnectivity(): void {
    const parameters = _.cloneDeep(this.radiusAuthentication);

    parameters.testConnectivity.password = null;
    parameters.testConnectivity.name = null;
    this.testResult = '';
    this.testResultServer = '';
    this.radiusAuthenticationApiService.testAuthenticationRadiusConfiguration(parameters).subscribe(() => {
      this.testResultServer = 'RADIUS server connection test successful';
    }, (fail) => {
      if (fail.error && fail.error.description){
        this.testResultServer = 'Failed: ' + fail.error.description;
      } else{
        this.testResultServer = 'Failed: please check your parameters';
      }
    });
  }

  initialization(): void {
    forkJoin([
      this.radiusAuthenticationApiService.getAuthenticationRadiusConfiguration(),
      this.securityPoliciesApiService.getSecurityPolicies()
    ]).subscribe(data => {
      this.setRadiusAuthenticationValues(data[0]);
      this.loaderService.hideMainContainer();
      this.securityLevelsOptions = data[1].slice(0, 3);
      this.securityLevelsOptions.push({name: 'Reject', id: -1});

    });
  }

  setRadiusAuthenticationValues(radiusServer): void {
    radiusServer.defaultRole = (radiusServer.defaultRole === null) ? -1 : radiusServer.defaultRole;
    radiusServer.testConnectivity = _.cloneDeep(this.radiusAuthentication.testConnectivity);
    this.radiusAuthentication = radiusServer;
  }

  disableServerTestAndSubmit(): boolean{
    if (!_.isEmpty(this.radiusAuthentication.additionalAttributeKey) && (_.isEmpty(this.radiusAuthentication.additionalAttributeValue))){
      return  true;
    }
    if (!_.isEmpty(this.radiusAuthentication.additionalAttributeValue) && (_.isEmpty(this.radiusAuthentication.additionalAttributeKey))){
      return  true;
    }
    if (this.radiusAuthentication.nasPort < 0 || this.radiusAuthentication.nasPort > 65536){
      return true;
    }
    if (this.radiusAuthentication.port < 0 || this.radiusAuthentication.port > 65536){
      return true;
    }
  }
}
